import { Pipe, PipeTransform } from '@angular/core';
import { filesize, FileSizeOptions } from 'filesize';

@Pipe({
  name: 'filesize',
})
export class FilesizePipe implements PipeTransform {
  transform(value: string | number | bigint, options?: FileSizeOptions): unknown {
    return filesize(value, options);
  }
}
